var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"welcome_buttons"},[_c('SignInRegister'),_vm._m(0)],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"signInRegister_btns gridRow"},[_c('a',{staticClass:"btn button btn_purple",attrs:{"href":"/MyLotto-Rewards/Help"}},[_vm._v("FAQ")])])
}]

export { render, staticRenderFns }